import React from 'react'
import styled from 'styled-components'
import SearchMobileComponent from './SearchMobileComponent'
import { device } from './Breakpoints'

const MobileNavigation = styled.div`
  @media ${device.mobileL} {
    display: block;
  }
  form {
    background: #ff8f8c;
    padding: 0.5em 1em;
    position: relative;
    svg {
      position: absolute;
      top: 11px;
      left: 24px;
      z-index: 999999;
      font-size: 1.7em;
    }
    input {
      border-radius: 50px;
      border: 1px solid #ffffff;
      padding: 0.7em 2.5em;
      color: #ffffff;
      background: transparent;
      width: 100%;
      box-sizing: border-box;
      ::placeholder {
        color: #ffffff;
      }
    }
    @media ${device.laptop} {
      display: block;
    }
  }
`

const SearchMobile = () => (
  <MobileNavigation>
    <SearchMobileComponent />
  </MobileNavigation>
)

export default SearchMobile
